module.exports = {"needText":"Want more images?","requestText":"Request additional images from the seller","provideMoreImagesText":"We'll contact the dealer to provide more images.","contactDealer":"Contact Seller","requestImages":"Request more images"}


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Carousel/RequestMoreImages/requestMoreImagesCopy.json
// module id = 2216
// module chunks = 4